export default __webpack_public_path__ + "static/media/bg2.1d2b41d4.jpg";